module.exports = __webpack_public_path__ + "img/art-work-icon5.114dd027.png";